/*!
 *
 *   @bornfight/gocart v1.0.9
 *
 *
 *   Copyright (c) Bornfight (https://www.bornfight.com/)
 *
 *   This source code is licensed under the MIT license found in the
 *   LICENSE file in the root directory of this source tree.
 *
 */
// const topperHandles = ['perfect-probiotics', 'perfect-wild-alaskan-salmon-oil', 'perfect-digestion', 'perfect-immunity','the-canine-cocomega-effect-book'];
if (market_handle == "us") {
  var topperHandles = [
    "perfect-immunity",
    "perfect-probiotics",
    "perfect-digestion",
    "the-canine-cocomega-effect-book",
    "charity-poop-bags",
  ];
} else {
  var topperHandles = [];
}

!(function (t, e) {
  "object" === typeof exports && "object" === typeof module
    ? (module.exports = e())
    : "function" === typeof define && define.amd
    ? define("GoCart", [], e)
    : "object" === typeof exports
    ? (exports.GoCart = e())
    : (t.GoCart = e());
})(window, function () {
  return (function (t) {
    var e = {};

    function __webpack_require__(r) {
      if (e[r]) return e[r].exports;
      var a = (e[r] = {
        i: r,
        l: !1,
        exports: {},
      });
      return (
        t[r].call(a.exports, a, a.exports, __webpack_require__),
        (a.l = !0),
        a.exports
      );
    }
    return (
      (__webpack_require__.m = t),
      (__webpack_require__.c = e),
      (__webpack_require__.d = function (t, e, r) {
        __webpack_require__.o(t, e) ||
          Object.defineProperty(t, e, {
            enumerable: !0,
            get: r,
          });
      }),
      (__webpack_require__.r = function (t) {
        "undefined" !== typeof Symbol &&
          Symbol.toStringTag &&
          Object.defineProperty(t, Symbol.toStringTag, {
            value: "Module",
          }),
          Object.defineProperty(t, "__esModule", {
            value: !0,
          });
      }),
      (__webpack_require__.t = function (t, e) {
        if ((1 & e && (t = __webpack_require__(t)), 8 & e)) return t;
        if (4 & e && "object" === typeof t && t && t.__esModule) return t;
        var r = Object.create(null);
        if (
          (__webpack_require__.r(r),
          Object.defineProperty(r, "default", {
            enumerable: !0,
            value: t,
          }),
          2 & e && "string" != typeof t)
        )
          for (var a in t)
            __webpack_require__.d(
              r,
              a,
              function (e) {
                return t[e];
              }.bind(null, a)
            );
        return r;
      }),
      (__webpack_require__.n = function (t) {
        var e =
          t && t.__esModule
            ? function () {
                return t.default;
              }
            : function () {
                return t;
              };
        return __webpack_require__.d(e, "a", e), e;
      }),
      (__webpack_require__.o = function (t, e) {
        return Object.prototype.hasOwnProperty.call(t, e);
      }),
      (__webpack_require__.p = ""),
      __webpack_require__((__webpack_require__.s = 1))
    );
  })([
    function (t, e, r) {
      var a = r(3),
        o = /^(?:submit|button|image|reset|file)$/i,
        n = /^(?:input|select|textarea|keygen)/i,
        i = /(\[[^\[\]]*\])/g;

      function hash_serializer(t, e, r) {
        if (e.match(i)) {
          !(function hash_assign(t, e, r) {
            if (0 === e.length) return (t = r);
            var a = e.shift(),
              o = a.match(/^\[(.+?)\]$/);
            if ("[]" === a)
              return (
                (t = t || []),
                Array.isArray(t)
                  ? t.push(hash_assign(null, e, r))
                  : ((t._values = t._values || []),
                    t._values.push(hash_assign(null, e, r))),
                t
              );
            if (o) {
              var n = o[1],
                i = +n;
              isNaN(i)
                ? ((t = t || {})[n] = hash_assign(t[n], e, r))
                : ((t = t || [])[i] = hash_assign(t[i], e, r));
            } else t[a] = hash_assign(t[a], e, r);
            return t;
          })(
            t,
            (function (t) {
              var e = [],
                r = new RegExp(i),
                a = /^([^\[\]]*)/.exec(t);
              for (a[1] && e.push(a[1]); null !== (a = r.exec(t)); )
                e.push(a[1]);
              return e;
            })(e),
            r
          );
        } else {
          var a = t[e];
          a ? (Array.isArray(a) || (t[e] = [a]), t[e].push(r)) : (t[e] = r);
        }
        return t;
      }

      function str_serialize(t, e, r) {
        return (
          (r = r.replace(/(\r)?\n/g, "\r\n")),
          (r = (r = encodeURIComponent(r)).replace(/%20/g, "+")),
          t + (t ? "&" : "") + encodeURIComponent(e) + "=" + r
        );
      }
      t.exports = function (t, e) {
        "object" != a(e)
          ? (e = {
              hash: !!e,
            })
          : void 0 === e.hash && (e.hash = !0);
        for (
          var r = e.hash ? {} : "",
            i = e.serializer || (e.hash ? hash_serializer : str_serialize),
            s = t && t.elements ? t.elements : [],
            c = Object.create(null),
            l = 0;
          l < s.length;
          ++l
        ) {
          var u = s[l];
          if (
            (e.disabled || !u.disabled) &&
            u.name &&
            n.test(u.nodeName) &&
            !o.test(u.type)
          ) {
            var d = u.name,
              f = u.value;
            if (
              (("checkbox" !== u.type && "radio" !== u.type) ||
                u.checked ||
                (f = void 0),
              e.empty)
            ) {
              if (
                ("checkbox" !== u.type || u.checked || (f = ""),
                "radio" === u.type &&
                  (c[u.name] || u.checked
                    ? u.checked && (c[u.name] = !0)
                    : (c[u.name] = !1)),
                void 0 == f && "radio" == u.type)
              )
                continue;
            } else if (!f) continue;
            if ("select-multiple" !== u.type) r = i(r, d, f);
            else {
              f = [];
              for (var h = u.options, y = !1, p = 0; p < h.length; ++p) {
                var m = h[p],
                  b = e.empty && !m.value,
                  v = m.value || b;
                m.selected &&
                  v &&
                  ((y = !0),
                  (r =
                    e.hash && "[]" !== d.slice(d.length - 2)
                      ? i(r, d + "[]", m.value)
                      : i(r, d, m.value)));
              }
              !y && e.empty && (r = i(r, d, ""));
            }
          }
        }
        if (e.empty) for (var d in c) c[d] || (r = i(r, d, ""));
        return r;
      };
    },
    function (t, e, r) {
      t.exports = r(4);
    },
    function (t, e, r) {},
    function (t, e) {
      function _typeof2(t) {
        return (_typeof2 =
          "function" === typeof Symbol && "symbol" === typeof Symbol.iterator
            ? function (t) {
                return typeof t;
              }
            : function (t) {
                return t &&
                  "function" === typeof Symbol &&
                  t.constructor === Symbol &&
                  t !== Symbol.prototype
                  ? "symbol"
                  : typeof t;
              })(t);
      }

      function _typeof(e) {
        return (
          "function" === typeof Symbol && "symbol" === _typeof2(Symbol.iterator)
            ? (t.exports = _typeof =
                function (t) {
                  return _typeof2(t);
                })
            : (t.exports = _typeof =
                function (t) {
                  return t &&
                    "function" === typeof Symbol &&
                    t.constructor === Symbol &&
                    t !== Symbol.prototype
                    ? "symbol"
                    : _typeof2(t);
                }),
          _typeof(e)
        );
      }
      t.exports = _typeof;
    },
    function (t, e, r) {
      "use strict";
      r.r(e);
      r(2);
      var a = "${{amount}}";

      function formatMoney(t, e) {
        "string" === typeof t && (t = t.replace(".", ""));
        var r = "",
          o = /\{\{\s*(\w+)\s*\}\}/,
          n = e || a;

        function formatWithDelimiters(t) {
          var e =
              arguments.length > 1 && void 0 !== arguments[1]
                ? arguments[1]
                : 2,
            r =
              arguments.length > 2 && void 0 !== arguments[2]
                ? arguments[2]
                : ",",
            a =
              arguments.length > 3 && void 0 !== arguments[3]
                ? arguments[3]
                : ".";
          if (isNaN(t) || null == t) return 0;
          var o = (t = (t / 100).toFixed(e)).split(".");
          return (
            o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1".concat(r)) +
            (o[1] ? a + o[1] : "")
          );
        }
        switch (n.match(o)[1]) {
          case "amount":
            r = formatWithDelimiters(t, 2);
            break;
          case "amount_no_comma":
            r = formatWithDelimiters(t, 2).replace(",", "");
            break;
          case "amount_no_decimals":
            r = formatWithDelimiters(t, 0);
            break;
          case "amount_with_comma_separator":
            r = formatWithDelimiters(t, 2, ".", ",");
            break;
          case "amount_no_decimals_with_comma_separator":
            r = formatWithDelimiters(t, 0, ".", ",");
        }
        return n.replace(o, r);
      }

      function _typeof(t) {
        return (_typeof =
          "function" === typeof Symbol && "symbol" === typeof Symbol.iterator
            ? function (t) {
                return typeof t;
              }
            : function (t) {
                return t &&
                  "function" === typeof Symbol &&
                  t.constructor === Symbol &&
                  t !== Symbol.prototype
                  ? "symbol"
                  : typeof t;
              })(t);
      }
      var o =
          ("undefined" !== typeof globalThis && globalThis) ||
          ("undefined" !== typeof self && self) ||
          ("undefined" !== typeof o && o),
        n = {
          searchParams: "URLSearchParams" in o,
          iterable: "Symbol" in o && "iterator" in Symbol,
          blob:
            "FileReader" in o &&
            "Blob" in o &&
            (function () {
              try {
                return new Blob(), !0;
              } catch (t) {
                return !1;
              }
            })(),
          formData: "FormData" in o,
          arrayBuffer: "ArrayBuffer" in o,
        };
      if (n.arrayBuffer)
        var i = [
            "[object Int8Array]",
            "[object Uint8Array]",
            "[object Uint8ClampedArray]",
            "[object Int16Array]",
            "[object Uint16Array]",
            "[object Int32Array]",
            "[object Uint32Array]",
            "[object Float32Array]",
            "[object Float64Array]",
          ],
          s =
            ArrayBuffer.isView ||
            function (t) {
              return t && i.indexOf(Object.prototype.toString.call(t)) > -1;
            };

      function normalizeName(t) {
        if (
          ("string" !== typeof t && (t = String(t)),
          /[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(t) || "" === t)
        )
          throw new TypeError("Invalid character in header field name");
        return t.toLowerCase();
      }

      function normalizeValue(t) {
        return "string" !== typeof t && (t = String(t)), t;
      }

      function iteratorFor(t) {
        var e = {
          next: function () {
            var e = t.shift();
            return {
              done: void 0 === e,
              value: e,
            };
          },
        };
        return (
          n.iterable &&
            (e[Symbol.iterator] = function () {
              return e;
            }),
          e
        );
      }

      function Headers(t) {
        (this.map = {}),
          t instanceof Headers
            ? t.forEach(function (t, e) {
                this.append(e, t);
              }, this)
            : Array.isArray(t)
            ? t.forEach(function (t) {
                this.append(t[0], t[1]);
              }, this)
            : t &&
              Object.getOwnPropertyNames(t).forEach(function (e) {
                this.append(e, t[e]);
              }, this);
      }

      function consumed(t) {
        if (t.bodyUsed) return Promise.reject(new TypeError("Already read"));
        t.bodyUsed = !0;
      }

      function fileReaderReady(t) {
        return new Promise(function (e, r) {
          (t.onload = function () {
            e(t.result);
          }),
            (t.onerror = function () {
              r(t.error);
            });
        });
      }

      function readBlobAsArrayBuffer(t) {
        var e = new FileReader(),
          r = fileReaderReady(e);
        return e.readAsArrayBuffer(t), r;
      }

      function bufferClone(t) {
        if (t.slice) return t.slice(0);
        var e = new Uint8Array(t.byteLength);
        return e.set(new Uint8Array(t)), e.buffer;
      }

      function Body() {
        return (
          (this.bodyUsed = !1),
          (this._initBody = function (t) {
            var e;
            (this.bodyUsed = this.bodyUsed),
              (this._bodyInit = t),
              t
                ? "string" === typeof t
                  ? (this._bodyText = t)
                  : n.blob && Blob.prototype.isPrototypeOf(t)
                  ? (this._bodyBlob = t)
                  : n.formData && FormData.prototype.isPrototypeOf(t)
                  ? (this._bodyFormData = t)
                  : n.searchParams && URLSearchParams.prototype.isPrototypeOf(t)
                  ? (this._bodyText = t.toString())
                  : n.arrayBuffer &&
                    n.blob &&
                    (e = t) &&
                    DataView.prototype.isPrototypeOf(e)
                  ? ((this._bodyArrayBuffer = bufferClone(t.buffer)),
                    (this._bodyInit = new Blob([this._bodyArrayBuffer])))
                  : n.arrayBuffer &&
                    (ArrayBuffer.prototype.isPrototypeOf(t) || s(t))
                  ? (this._bodyArrayBuffer = bufferClone(t))
                  : (this._bodyText = t = Object.prototype.toString.call(t))
                : (this._bodyText = ""),
              this.headers.get("content-type") ||
                ("string" === typeof t
                  ? this.headers.set("content-type", "text/plain;charset=UTF-8")
                  : this._bodyBlob && this._bodyBlob.type
                  ? this.headers.set("content-type", this._bodyBlob.type)
                  : n.searchParams &&
                    URLSearchParams.prototype.isPrototypeOf(t) &&
                    this.headers.set(
                      "content-type",
                      "application/x-www-form-urlencoded;charset=UTF-8"
                    ));
          }),
          n.blob &&
            ((this.blob = function () {
              var t = consumed(this);
              if (t) return t;
              if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
              if (this._bodyArrayBuffer)
                return Promise.resolve(new Blob([this._bodyArrayBuffer]));
              if (this._bodyFormData)
                throw new Error("could not read FormData body as blob");
              return Promise.resolve(new Blob([this._bodyText]));
            }),
            (this.arrayBuffer = function () {
              if (this._bodyArrayBuffer) {
                var t = consumed(this);
                return (
                  t ||
                  (ArrayBuffer.isView(this._bodyArrayBuffer)
                    ? Promise.resolve(
                        this._bodyArrayBuffer.buffer.slice(
                          this._bodyArrayBuffer.byteOffset,
                          this._bodyArrayBuffer.byteOffset +
                            this._bodyArrayBuffer.byteLength
                        )
                      )
                    : Promise.resolve(this._bodyArrayBuffer))
                );
              }
              return this.blob().then(readBlobAsArrayBuffer);
            })),
          (this.text = function () {
            var t = consumed(this);
            if (t) return t;
            if (this._bodyBlob)
              return (function (t) {
                var e = new FileReader(),
                  r = fileReaderReady(e);
                return e.readAsText(t), r;
              })(this._bodyBlob);
            if (this._bodyArrayBuffer)
              return Promise.resolve(
                (function (t) {
                  for (
                    var e = new Uint8Array(t), r = new Array(e.length), a = 0;
                    a < e.length;
                    a++
                  )
                    r[a] = String.fromCharCode(e[a]);
                  return r.join("");
                })(this._bodyArrayBuffer)
              );
            if (this._bodyFormData)
              throw new Error("could not read FormData body as text");
            return Promise.resolve(this._bodyText);
          }),
          n.formData &&
            (this.formData = function () {
              return this.text().then(decode);
            }),
          (this.json = function () {
            return this.text().then(JSON.parse);
          }),
          this
        );
      }
      (Headers.prototype.append = function (t, e) {
        (t = normalizeName(t)), (e = normalizeValue(e));
        var r = this.map[t];
        this.map[t] = r ? r + ", " + e : e;
      }),
        (Headers.prototype.delete = function (t) {
          delete this.map[normalizeName(t)];
        }),
        (Headers.prototype.get = function (t) {
          return (t = normalizeName(t)), this.has(t) ? this.map[t] : null;
        }),
        (Headers.prototype.has = function (t) {
          return this.map.hasOwnProperty(normalizeName(t));
        }),
        (Headers.prototype.set = function (t, e) {
          this.map[normalizeName(t)] = normalizeValue(e);
        }),
        (Headers.prototype.forEach = function (t, e) {
          for (var r in this.map)
            this.map.hasOwnProperty(r) && t.call(e, this.map[r], r, this);
        }),
        (Headers.prototype.keys = function () {
          var t = [];
          return (
            this.forEach(function (e, r) {
              t.push(r);
            }),
            iteratorFor(t)
          );
        }),
        (Headers.prototype.values = function () {
          var t = [];
          return (
            this.forEach(function (e) {
              t.push(e);
            }),
            iteratorFor(t)
          );
        }),
        (Headers.prototype.entries = function () {
          var t = [];
          return (
            this.forEach(function (e, r) {
              t.push([r, e]);
            }),
            iteratorFor(t)
          );
        }),
        n.iterable &&
          (Headers.prototype[Symbol.iterator] = Headers.prototype.entries);
      var c = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];

      function Request(t, e) {
        if (!(this instanceof Request))
          throw new TypeError(
            'Please use the "new" operator, this DOM object constructor cannot be called as a function.'
          );
        var r = (e = e || {}).body;
        if (t instanceof Request) {
          if (t.bodyUsed) throw new TypeError("Already read");
          (this.url = t.url),
            (this.credentials = t.credentials),
            e.headers || (this.headers = new Headers(t.headers)),
            (this.method = t.method),
            (this.mode = t.mode),
            (this.signal = t.signal),
            r || null == t._bodyInit || ((r = t._bodyInit), (t.bodyUsed = !0));
        } else this.url = String(t);
        if (
          ((this.credentials =
            e.credentials || this.credentials || "same-origin"),
          (!e.headers && this.headers) ||
            (this.headers = new Headers(e.headers)),
          (this.method = (function (t) {
            var e = t.toUpperCase();
            return c.indexOf(e) > -1 ? e : t;
          })(e.method || this.method || "GET")),
          (this.mode = e.mode || this.mode || null),
          (this.signal = e.signal || this.signal),
          (this.referrer = null),
          ("GET" === this.method || "HEAD" === this.method) && r)
        )
          throw new TypeError("Body not allowed for GET or HEAD requests");
        if (
          (this._initBody(r),
          ("GET" === this.method || "HEAD" === this.method) &&
            ("no-store" === e.cache || "no-cache" === e.cache))
        ) {
          var a = /([?&])_=[^&]*/;
          if (a.test(this.url))
            this.url = this.url.replace(a, "$1_=" + new Date().getTime());
          else {
            this.url +=
              (/\?/.test(this.url) ? "&" : "?") + "_=" + new Date().getTime();
          }
        }
      }

      function decode(t) {
        var e = new FormData();
        return (
          t
            .trim()
            .split("&")
            .forEach(function (t) {
              if (t) {
                var r = t.split("="),
                  a = r.shift().replace(/\+/g, " "),
                  o = r.join("=").replace(/\+/g, " ");
                e.append(decodeURIComponent(a), decodeURIComponent(o));
              }
            }),
          e
        );
      }

      function parseHeaders(t) {
        var e = new Headers();
        return (
          t
            .replace(/\r?\n[\t ]+/g, " ")
            .split(/\r?\n/)
            .forEach(function (t) {
              var r = t.split(":"),
                a = r.shift().trim();
              if (a) {
                var o = r.join(":").trim();
                e.append(a, o);
              }
            }),
          e
        );
      }

      function Response(t, e) {
        if (!(this instanceof Response))
          throw new TypeError(
            'Please use the "new" operator, this DOM object constructor cannot be called as a function.'
          );
        e || (e = {}),
          (this.type = "default"),
          (this.status = void 0 === e.status ? 200 : e.status),
          (this.ok = this.status >= 200 && this.status < 300),
          (this.statusText = "statusText" in e ? e.statusText : ""),
          (this.headers = new Headers(e.headers)),
          (this.url = e.url || ""),
          this._initBody(t);
      }
      (Request.prototype.clone = function () {
        return new Request(this, {
          body: this._bodyInit,
        });
      }),
        Body.call(Request.prototype),
        Body.call(Response.prototype),
        (Response.prototype.clone = function () {
          return new Response(this._bodyInit, {
            status: this.status,
            statusText: this.statusText,
            headers: new Headers(this.headers),
            url: this.url,
          });
        }),
        (Response.error = function () {
          var t = new Response(null, {
            status: 0,
            statusText: "",
          });
          return (t.type = "error"), t;
        });
      var l = [301, 302, 303, 307, 308];
      Response.redirect = function (t, e) {
        if (-1 === l.indexOf(e)) throw new RangeError("Invalid status code");
        return new Response(null, {
          status: e,
          headers: {
            location: t,
          },
        });
      };
      var u = o.DOMException;
      try {
        new u();
      } catch (y) {
        ((u = function (t, e) {
          (this.message = t), (this.name = e);
          var r = Error(t);
          this.stack = r.stack;
        }).prototype = Object.create(Error.prototype)),
          (u.prototype.constructor = u);
      }

      function fetch(t, e) {
        return new Promise(function (r, a) {
          var i = new Request(t, e);
          if (i.signal && i.signal.aborted)
            return a(new u("Aborted", "AbortError"));
          var s = new XMLHttpRequest();

          function abortXhr() {
            s.abort();
          }
          (s.onload = function () {
            var t = {
              status: s.status,
              statusText: s.statusText,
              headers: parseHeaders(s.getAllResponseHeaders() || ""),
            };
            t.url =
              "responseURL" in s
                ? s.responseURL
                : t.headers.get("X-Request-URL");
            var e = "response" in s ? s.response : s.responseText;
            setTimeout(function () {
              r(new Response(e, t));
            }, 0);
          }),
            (s.onerror = function () {
              setTimeout(function () {
                a(new TypeError("Network request failed"));
              }, 0);
            }),
            (s.ontimeout = function () {
              setTimeout(function () {
                a(new TypeError("Network request failed"));
              }, 0);
            }),
            (s.onabort = function () {
              setTimeout(function () {
                a(new u("Aborted", "AbortError"));
              }, 0);
            }),
            s.open(
              i.method,
              (function (t) {
                try {
                  return "" === t && o.location.href ? o.location.href : t;
                } catch (e) {
                  return t;
                }
              })(i.url),
              !0
            ),
            "include" === i.credentials
              ? (s.withCredentials = !0)
              : "omit" === i.credentials && (s.withCredentials = !1),
            "responseType" in s &&
              (n.blob
                ? (s.responseType = "blob")
                : n.arrayBuffer &&
                  i.headers.get("Content-Type") &&
                  -1 !==
                    i.headers
                      .get("Content-Type")
                      .indexOf("application/octet-stream") &&
                  (s.responseType = "arraybuffer")),
            !e ||
            "object" !== _typeof(e.headers) ||
            e.headers instanceof Headers
              ? i.headers.forEach(function (t, e) {
                  s.setRequestHeader(e, t);
                })
              : Object.getOwnPropertyNames(e.headers).forEach(function (t) {
                  s.setRequestHeader(t, normalizeValue(e.headers[t]));
                }),
            i.signal &&
              (i.signal.addEventListener("abort", abortXhr),
              (s.onreadystatechange = function () {
                4 === s.readyState &&
                  i.signal.removeEventListener("abort", abortXhr);
              })),
            s.send("undefined" === typeof i._bodyInit ? null : i._bodyInit);
        });
      }
      (fetch.polyfill = !0),
        o.fetch ||
          ((o.fetch = fetch),
          (o.Headers = Headers),
          (o.Request = Request),
          (o.Response = Response));
      var d = r(0),
        f = r.n(d);

      function _defineProperties(t, e) {
        for (var r = 0; r < e.length; r++) {
          var a = e[r];
          (a.enumerable = a.enumerable || !1),
            (a.configurable = !0),
            "value" in a && (a.writable = !0),
            Object.defineProperty(t, a.key, a);
        }
      }

      async function _get_selling_plans(handle) {
        // Get selling plans
        return window
          .fetch(`/products/${handle}.js`, {
            credentials: "same-origin",
            method: "GET",
          })
          .then((response) => response.json());
      }

      function setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        let expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
      }

      function getCookie(cname) {
        let name = cname + "=";
        let ca = document.cookie.split(";");
        for (let i = 0; i < ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) == " ") {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "";
      }

      function getURLParameter(name) {
        return (
          decodeURIComponent(
            (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
              location.search
            ) || [null, ""])[1].replace(/\+/g, "%20")
          ) || null
        );
      }

      var h = (function () {
        function GoCart(t) {
          !(function (t, e) {
            if (!(t instanceof e))
              throw new TypeError("Cannot call a class as a function");
          })(this, GoCart);
          (this.defaults = Object.assign(
            {},
            {
              cartModalFail: ".js-go-cart-modal-fail",
              cartModalFailClose: ".js-go-cart-modal-fail-close",
              cartModal: ".js-go-cart-modal",
              cartModalClose: ".js-go-cart-modal-close",
              cartModalContent: ".js-go-cart-modal-content",
              cartDrawer: ".js-go-cart-drawer",
              cartDrawerContent: ".js-go-cart-drawer-content",
              cartDrawerSubTotal: ".js-go-cart-drawer-subtotal",
              cartDrawerExtraDscTotal: ".js-go-cart-drawer-extra_dsc_total",
              cartDrawerDscTotal: ".js-go-cart-drawer-dsc_price",
              cartDrawerFooter: ".js-go-cart-drawer-footer",
              cartDrawerClose: ".js-go-cart-drawer-close",
              cartMiniCart: ".js-go-cart-mini-cart",
              cartMiniCartContent: ".js-go-cart-mini-cart-content",
              cartMiniCartSubTotal: ".js-go-cart-mini-cart-subtotal",
              cartMiniCartFooter: ".js-go-cart-mini-cart-footer",
              cartTrigger: ".js-go-cart-trigger",
              cartOverlay: ".js-go-cart-overlay",
              cartCount: ".js-go-cart-counter",
              addToCart: ".js-go-cart-add-to-cart",
              buyNow: ".js-go-cart-buy-now",
              removeFromCart: ".js-go-cart-remove-from-cart",
              removeFromCartNoDot: "js-go-cart-remove-from-cart",
              itemQuantity: ".js-go-cart-quantity",
              itemQuantityPlus: ".js-go-cart-quantity-plus",
              itemQuantityMinus: ".js-go-cart-quantity-minus",
              itemSellingPlan: ".js-go-cart-selling-plan",
              cartMode: "drawer",
              drawerDirection: "right",
              displayModal: !1,
              moneyFormat: `${currency_sym}{{amount}}`,
              labelAddedToCart: "was added to your cart.",
              labelCartIsEmpty: "Your cart is currently empty!",
              labelQuantity: "",
              bfcm_promo: false,
              easter_promo: false,
              bfcm_code: "",
              bfcm_value_pct: 1,
              labelRemove:
                '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20"><path d="M15.89 14.696l-4.734-4.734 4.717-4.717c.4-.4.37-1.085-.03-1.485s-1.085-.43-1.485-.03L9.641 8.447 4.97 3.776c-.4-.4-1.085-.37-1.485.03s-.43 1.085-.03 1.485l4.671 4.671-4.688 4.688c-.4.4-.37 1.085.03 1.485s1.085.43 1.485.03l4.688-4.687 4.734 4.734c.4.4 1.085.37 1.485-.03s.43-1.085.03-1.485z"></path></svg>',

              selling_plan_group_mapping: {
                "Extra 5% off": {
                  price_adjustment: {
                    type: "percentage",
                    value: 5,
                  },
                  mappings: {
                    "Subscribe & Save 5%": {
                      3650879706: 23895965914,
                      3650912474: 23920115930,
                      3650945242: 23920148698,
                      24230428890: 23895965914,
                      24230461658: 23920115930,
                      24230494426: 23920148698,
                    },
                    "Subscribe & Save 10%": {
                      25609175258: 25609371866,
                      25609208026: 25609404634,
                      25609240794: 25609437402,
                    },
                    "Subscribe & Save 20%": {
                      3606151386: 24228200666,
                      3606184154: 24228823258,
                      3606216922: 24228856026,
                      24230527194: 24228200666,
                      24230559962: 24228823258,
                      24230592730: 24228856026,
                    },
                  },
                },
                "Extra 10% off": {
                  price_adjustment: {
                    type: "percentage",
                    value: 10,
                  },
                  mappings: {
                    "Subscribe & Save 5%": {
                      3650879706: 23920247002,
                      3650912474: 23920279770,
                      3650945242: 23920312538,
                      24230428890: 23920247002,
                      24230461658: 23920279770,
                      24230494426: 23920312538,
                    },
                    "Subscribe & Save 10%": {
                      25609175258: 25609470170,
                      25609208026: 25609502938,
                      25609240794: 25609535706,
                    },
                    "Subscribe & Save 20%": {
                      3606151386: 24228888794,
                      3606184154: 24228921562,
                      3606216922: 24228954330,
                      24230527194: 24228888794,
                      24230559962: 24228921562,
                      24230592730: 24228954330,
                    },
                  },
                },
                "Extra 15% off": {
                  price_adjustment: {
                    type: "percentage",
                    value: 15,
                  },
                  mappings: {
                    "Subscribe & Save 5%": {
                      3650879706: 23920345306,
                      3650912474: 23920378074,
                      3650945242: 23920410842,
                      24230428890: 23920345306,
                      24230461658: 23920378074,
                      24230494426: 23920410842,
                    },
                    "Subscribe & Save 10%": {
                      25609175258: 25609568474,
                      25609208026: 25609601242,
                      25609240794: 25609634010,
                    },
                    "Subscribe & Save 20%": {
                      3606151386: 24229150938,
                      3606184154: 24229183706,
                      3606216922: 24229216474,
                      24230527194: 24229150938,
                      24230559962: 24229183706,
                      24230592730: 24229216474,
                    },
                  },
                },
                "25% off member discount": {
                  price_adjustment: {
                    type: "percentage",
                    value: 25,
                  },
                  mappings: {
                    "Subscribe & Save 5%": {
                      3650879706: 24221253850,
                      3650912474: 24221286618,
                      3650945242: 24221319386,
                      24230428890: 24221253850,
                      24230461658: 24221286618,
                      24230494426: 24221319386,
                    },
                    "Subscribe & Save 10%": {
                      25609175258: 25609666778,
                      25609208026: 25609699546,
                      25609240794: 25609732314,
                    },
                    "Subscribe & Save 20%": {
                      3606151386: 24229249242,
                      3606184154: 24229282010,
                      3606216922: 24229314778,
                      24230527194: 24229249242,
                      24230559962: 24229282010,
                      24230592730: 24229314778,
                    },
                  },
                },
              },
              cart_obj: {},
              upsell_items_handles: [
                "perfect-immunity",
                "perfect-yumsauce",
                "perfect-probiotics",
                "perfect-digestion",
                "perfect-wild-alaskan-salmon-oil",
                "the-canine-cocomega-effect-book",
              ],
              upsell_items_obj: [],
              cartMemberSavings: ".js-member_savings",
              cartAddMembership: ".js_add_membership",
              cartNonMemberSavings: ".js-non-member-savings",
              cartMemberOrderSavings: ".js-member_order_savings",
            },
            t
          )),
            (this.cartModalFail = document.querySelector(
              this.defaults.cartModalFail
            )),
            (this.cartModalFailClose = document.querySelector(
              this.defaults.cartModalFailClose
            )),
            (this.cartModal = document.querySelector(this.defaults.cartModal)),
            (this.cartModalClose = document.querySelectorAll(
              this.defaults.cartModalClose
            )),
            (this.cartModalContent = document.querySelector(
              this.defaults.cartModalContent
            )),
            (this.cartDrawer = document.querySelector(
              this.defaults.cartDrawer
            )),
            (this.cartDrawerContent = document.querySelectorAll(
              this.defaults.cartDrawerContent
            )),
            (this.cartDrawerSubTotal = document.querySelectorAll(
              this.defaults.cartDrawerSubTotal
            )),
            (this.cartDrawerExtraDscTotal = document.querySelectorAll(
              this.defaults.cartDrawerExtraDscTotal
            )),
            (this.cartDrawerDscTotal = document.querySelectorAll(
              this.defaults.cartDrawerDscTotal
            )),
            (this.cartDrawerFooter = document.querySelector(
              this.defaults.cartDrawerFooter
            )),
            (this.cartDrawerClose = document.querySelector(
              this.defaults.cartDrawerClose
            )),
            (this.cartMiniCart = document.querySelector(
              this.defaults.cartMiniCart
            )),
            (this.cartMiniCartContent = document.querySelector(
              this.defaults.cartMiniCartContent
            )),
            (this.cartMiniCartSubTotal = document.querySelector(
              this.defaults.cartMiniCartSubTotal
            )),
            (this.cartMiniCartFooter = document.querySelector(
              this.defaults.cartMiniCartFooter
            )),
            (this.cartTrigger = document.querySelector(
              this.defaults.cartTrigger
            )),
            (this.cartOverlay = document.querySelector(
              this.defaults.cartOverlay
            )),
            (this.cartCount = document.querySelector(this.defaults.cartCount)),
            (this.addToCart = document.querySelectorAll(
              this.defaults.addToCart
            )),
            (this.buyNow = document.querySelector(this.defaults.buyNow)),
            (this.removeFromCart = this.defaults.removeFromCart),
            (this.removeFromCartNoDot = this.defaults.removeFromCartNoDot),
            (this.itemQuantity = this.defaults.itemQuantity),
            (this.itemQuantityPlus = this.defaults.itemQuantityPlus),
            (this.itemQuantityMinus = this.defaults.itemQuantityMinus),
            (this.cartMode = this.defaults.cartMode),
            (this.drawerDirection = this.defaults.drawerDirection),
            (this.displayModal = this.defaults.displayModal),
            (this.moneyFormat = this.defaults.moneyFormat),
            (this.labelAddedToCart = this.defaults.labelAddedToCart),
            (this.labelCartIsEmpty = this.defaults.labelCartIsEmpty),
            (this.labelQuantity = this.defaults.labelQuantity),
            (this.labelRemove = this.defaults.labelRemove),
            (this.selling_plan_group_mapping =
              this.defaults.selling_plan_group_mapping),
            (this.original_total_price = this.defaults.original_total_price),
            (this.upsell_items_handles = this.defaults.upsell_items_handles),
            (this.upsell_items_obj = this.defaults.upsell_items_obj),
            (this.cartMemberSavings = document.querySelectorAll(
              this.defaults.cartMemberSavings
            )),
            (this.cartAddMembership = document.querySelectorAll(
              this.defaults.cartAddMembership
            )),
            (this.cartNonMemberSavings = document.querySelectorAll(
              this.defaults.cartNonMemberSavings
            )),
            (this.cartMemberOrderSavings = document.querySelectorAll(
              this.defaults.cartMemberOrderSavings
            )),
            (this.bfcm_promo = this.defaults.bfcm_promo),
            (this.bfcm_code = this.defaults.bfcm_code),
            (this.bfcm_value_pct = this.defaults.bfcm_value_pct),
            (this.easter_promo = this.defaults.easter_promo);
          this.init();
        }
        var t, e, r;
        return (
          (t = GoCart),
          (r = [
            {
              key: "removeItemAnimation",
              value: function (t) {
                t.classList.add("is-invisible");
              },
            },
          ]),
          (e = [
            {
              key: "init",
              value: function () {
                var t = this;
                if (
                  this.upsell_items_handles.length &&
                  !this.upsell_items_obj.length
                ) {
                  this.initUpsellItems();
                }
                this.fetchCart(),
                  this.checkBFCMPromo(),
                  this.isDrawerMode && this.setDrawerDirection(),
                  document.addEventListener(
                    "click",
                    async function (e) {
                      if (e.target.matches(t.defaults.addToCart)) {
                        e.preventDefault();
                        // for (var r = e.target.parentNode;
                        //     "form" !== r.tagName.toLowerCase();) r = r.parentNode;
                        // var a = r.getAttribute("id");
                        var a = jQuery("form", ".product-type").attr("id");
                        var handle = jQuery("form", ".product-type").attr(
                          "data-handle"
                        );
                        if (handle.includes("sampler")) {
                          var samples_handles = [];
                          var cart = t.cart_obj;
                          cart.items.forEach((i) => {
                            if (i.handle.includes("sampler")) {
                              samples_handles.push(i.handle);
                            }
                          });
                          if (samples_handles.includes(handle)) {
                            return;
                          }
                        }
                        t.addItemToCart(a);
                      }
                    },
                    !1
                  ),
                  $(this.buyNow).on("click", function (e) {
                    e.preventDefault();
                    var form_id = jQuery("form", ".product-type").attr("id");
                    var form = document.querySelector("#".concat(form_id)),
                      a = f()(form, {
                        hash: !0,
                      });
                    var form_obj = JSON.stringify(a);
                    var item_lnk = `items[][id]=${a.id}%26items[][quantity]=${a.quantity}`;
                    if (a.hasOwnProperty("selling_plan")) {
                      item_lnk = item_lnk.concat(
                        `%26items[][selling_plan]=${a.selling_plan}`
                      );
                    }
                    var lnk = `/cart/clear?return_to=/cart/add?${item_lnk}%26return_to=/checkout`;
                    window.location = lnk;
                  }),
                  $(this.cartAddMembership).on("click", function () {
                    t.addItem(44284368290010, 1, 24372019418);
                  }),
                  jQuery(".js-go-cart-trigger").on("click", function () {
                    t.isDrawerMode ? t.openCartDrawer() : t.openMiniCart(),
                      t.openCartOverlay();
                  }),
                  this.cartOverlay.addEventListener("click", function () {
                    t.closeFailModal(),
                      t.closeCartModal(),
                      t.isDrawerMode ? t.closeCartDrawer() : t.closeMiniCart(),
                      t.closeCartOverlay();
                  }),
                  this.isDrawerMode &&
                    this.cartDrawerClose.addEventListener("click", function () {
                      t.closeCartDrawer(), t.closeCartOverlay();
                    }),
                  this.displayModal &&
                    this.cartModalClose.forEach(function (e) {
                      e.addEventListener("click", function () {
                        t.closeFailModal(),
                          t.closeCartModal(),
                          t.isDrawerMode
                            ? t.closeCartDrawer()
                            : t.closeMiniCart(),
                          t.closeCartOverlay();
                      });
                    }),
                  this.cartModalFailClose.addEventListener(
                    "click",
                    function () {
                      t.closeFailModal(),
                        t.closeCartModal(),
                        t.isDrawerMode
                          ? t.closeCartDrawer()
                          : t.closeMiniCart(),
                        t.closeCartOverlay();
                    }
                  );
              },
            },
            {
              key: "fetchCartNoHandler",
              value: function (t) {
                var e = this;
                return window
                  .fetch("/cart.js", {
                    credentials: "same-origin",
                    method: "GET",
                  })
                  .then(function (t) {
                    return t.json();
                  })
                  .then(function (r) {
                    return r;
                  })
                  .catch(function (t) {
                    throw (e.ajaxRequestFail(), new Error(t));
                  });
              },
            },
            {
              key: "checkBFCMPromo",
              value: function () {
                var e = this;
                // Check for BFCM promo
                // ||
                //     codes_cookies.includes("BFCM-55") ||
                //     codes_cookies.includes("CYBER-60"
                var codes_cookies = getCookie("discount_code");
                codes_cookies = codes_cookies.split("%2C");

                if (codes_cookies) {
                  if (codes_cookies.includes("PAWLUV")) {
                    //      console.log("PAWLUV")
                    e.bfcm_code = "PAWLUV";
                    e.bfcm_value_pct = 0.8;
                    $(".collections_bfcm_banner").text(
                      "Pawluv offer has been applied. Shop now before the sale ends."
                    );
                    $(".go_cart_code_banner").text(
                      "✨ Promo code PAWLUV is applied. ✨"
                    );
                    $(".collections_bfcm_banner").show();
                    $(".go_cart_code_banner").show();
                  } else if (codes_cookies.includes("SPRING20")) {
                    e.easter_promo = true;
                    // e.bfcm_promo = true;
                    e.bfcm_code = "SPRING20";
                    e.bfcm_value_pct = 0.8;
                    $(".collections_bfcm_banner").text(
                      "SPRING20 offer has been applied. Shop now before the sale ends."
                    );
                    $(".go_cart_code_banner").text(
                      "✨ Promo code SPRING20 is applied. ✨"
                    );
                    $(".collections_bfcm_banner").show();
                    $(".go_cart_code_banner").show();
                  }
                }

                if (codes_cookies) {
                  if (
                    codes_cookies.includes("BFCM") ||
                    codes_cookies.includes("BFCM-55") ||
                    codes_cookies.includes("CYBER-60") ||
                    codes_cookies.includes("HOWLIDAY") ||
                    codes_cookies.includes("MEMDAY25")
                  ) {
                    e.bfcm_promo = true;
                    if (codes_cookies.includes("CYBER-60")) {
                      e.bfcm_code = "CYBER-60";
                      e.bfcm_value_pct = 0.65;
                      $(".collections_bfcm_banner").text(
                        "Cyber Monday offer has been applied. Shop now before the sale ends."
                      );
                      $(".go_cart_code_banner").text(
                        "✨ Promo code CYBER-60 is applied. ✨"
                      );
                    } else if (codes_cookies.includes("BFCM-55")) {
                      e.bfcm_code = "BFCM-55";
                      e.bfcm_value_pct = 0.7;
                      $(".go_cart_code_banner").text(
                        "✨ Promo code BFCM-55 is applied. ✨"
                      );
                    } else if (codes_cookies.includes("HOWLIDAY")) {
                      e.bfcm_code = "HOWLIDAY";
                      e.bfcm_value_pct = 0.85;
                      $(".collections_bfcm_banner").text(
                        "Howl-iday offer has been applied. Shop now before the sale ends."
                      );
                      $(".go_cart_code_banner").text(
                        "✨ Promo code HOWLIDAY is applied. ✨"
                      );
                    } else if (codes_cookies.includes("MEMDAY25")) {
                      e.bfcm_code = "MEMDAY25";
                      e.bfcm_value_pct = 0.80;
                      $(".collections_bfcm_banner").text(
                        "Memorial Day offer has been applied. Shop now before the sale ends."
                      );
                      $(".go_cart_code_banner").text(
                        "✨ Promo code MEMDAY25 is applied. ✨"
                      );
                    }
                    else {
                      e.bfcm_code = "BFCM";
                      e.bfcm_value_pct = 0.75;
                    }

                    $(".collections_bfcm_banner").show();
                    $(".go_cart_code_banner").show();
                  }
                }
              },
            },
            {
              key: "addBFCMGifts",
              value: function () {},
            },
            {
              key: "fetchCart",
              value: async function (t) {
                var e = this;
                $(".go-cart__checkout_btn").attr("disabled", true);
                window
                  .fetch("/cart.js", {
                    credentials: "same-origin",
                    method: "GET",
                  })
                  .then(function (t) {
                    return t.json();
                  })
                  .then(async function (cart) {
                    var _contains_membership = cart.items.filter(
                      (i) => i.variant_id == 44284368290010
                    ).length
                      ? true
                      : false;

                    const checkBFCMgifts = (cart, productIds) => {
                      const missingIds = productIds.filter(
                        (gifts) =>
                          !cart.some((item) => {
                            if (
                              item.id === 40383219990724 ||
                              item.id === 43331315892442
                            ) {
                              return (
                                item.id === gifts.id &&
                                !Object.hasOwn(item, "selling_plan_allocation")
                              );
                            }
                            return item.id === gifts.id;
                          })
                      );
                      return {
                        isComplete: missingIds.length === 0,
                        missingIds: missingIds,
                      };
                    };
                    const bfcm_gifts = checkBFCMgifts(cart.items, [
                      { id: 40383219990724 },
                      { id: 44284368290010, selling_plan: 24372019418 },
                    ]);

                    const easter_gifts = checkBFCMgifts(cart.items, [
                      { id: 43331315892442 },
                    ]);

                    cart.gocart = {
                      original_total_price: 0,
                      total_price: 0,
                      bundle_price: 0,
                      bundle_dsc: {},
                      items: [],
                      updates: [],
                      is_updated: true,
                      is_yum_member: checkMembership(),
                      contains_membership: _contains_membership,
                      contains_onetime: false,
                      contains_subs: false,
                      bfcm_promo: e.bfcm_promo,
                      easter_promo: e.easter_promo,
                      bfcm_code: e.bfcm_code,
                      bfcm_value_pct: e.bfcm_value_pct,
                      has_bfcm_gifts: bfcm_gifts.isComplete,
                      missing_bfcm_gifts: bfcm_gifts.missingIds,
                      missing_easter_gifts: easter_gifts.missingIds,
                    };

                    // 44284368290010 - Yum club var id
                    // 8223924453594 - donation product id

                    for (var i of cart.items) {
                      if (
                        i.hasOwnProperty("selling_plan_allocation") &&
                        i.variant_id != 44284368290010
                      ) {
                        cart.gocart.contains_subs = true;
                      } else {
                        cart.gocart.contains_onetime = true;
                      }
                      var _base_price = i.hasOwnProperty(
                        "selling_plan_allocation"
                      )
                        ? i.selling_plan_allocation.compare_at_price
                        : i.original_price;
                      var _sub_save_price = i.original_line_price;
                      var _bundle_price = i.original_line_price;
                      var _sub_save_base_price = i.original_price;

                      // Item is using the bundles selling plan (Extra 5%, Extra 10%, Extra 15%)
                      if (
                        i.hasOwnProperty("selling_plan_allocation") &&
                        Object.keys(e.selling_plan_group_mapping).includes(
                          i.selling_plan_allocation.selling_plan.options[0].name
                        )
                      ) {
                        var price_adjustment =
                          e.selling_plan_group_mapping[
                            i.selling_plan_allocation.selling_plan.options[0]
                              .name
                          ]["price_adjustment"];
                        _base_price =
                          i.selling_plan_allocation.compare_at_price;
                        _sub_save_base_price =
                          parseFloat(
                            formatMoney(
                              i.original_price /
                                (1 - price_adjustment.value / 100),
                              "{{amount}}"
                            )
                          ) * 100;
                        _sub_save_price = _sub_save_base_price * i.quantity;
                        _bundle_price = _sub_save_price;

                        cart.gocart.original_total_price += _sub_save_price;
                      } else {
                        cart.gocart.original_total_price +=
                          parseFloat(
                            formatMoney(
                              i.original_line_price,
                              "{{amount_no_comma}}"
                            )
                          ) * 100;
                      }

                      i.gocart = {
                        base_price: _base_price,
                        sub_save_price: _sub_save_price,
                        sub_save_base_price: _sub_save_base_price,
                        bundle_price: _bundle_price,
                      };
                    }
                    var _original_tp = cart.gocart.original_total_price / 100;
                    var _dsc_pct = 0;
                    if (
                      cart.gocart.is_yum_member ||
                      cart.gocart.contains_membership
                    ) {
                      _dsc_pct = 25;
                    } else {
                      if (
                        _original_tp >= bundle_t[1] &&
                        _original_tp < bundle_t[2]
                      ) {
                        _dsc_pct = 5;
                      } else if (
                        _original_tp >= bundle_t[2] &&
                        _original_tp < bundle_t[3]
                      ) {
                        _dsc_pct = 10;
                      } else if (_original_tp >= bundle_t[3]) {
                        _dsc_pct = 15;
                      }
                    }

                    for (var i of cart.items) {
                      var _bundle_base_price = parseFloat(
                        formatMoney(
                          i.gocart.sub_save_base_price * (1 - _dsc_pct / 100),
                          "{{amount}}"
                        )
                      );
                      if (
                        i.variant_id == 44284368290010 ||
                        i.product_id == 8223924453594
                      ) {
                        _bundle_base_price = parseFloat(
                          formatMoney(
                            i.gocart.sub_save_base_price,
                            "{{amount_no_comma}}"
                          )
                        );
                      }

                      i.gocart.bundle_price = Math.round(
                        _bundle_base_price * i.quantity * 100
                      );

                      cart.gocart.bundle_price += i.gocart.bundle_price;
                    }

                    cart.gocart.bundle_dsc = (function () {
                      for (var key in e.selling_plan_group_mapping) {
                        if (
                          e.selling_plan_group_mapping[key].price_adjustment
                            .value == _dsc_pct
                        ) {
                          return {
                            name: key,
                            value: _dsc_pct,
                            type: e.selling_plan_group_mapping[key]
                              .price_adjustment.type,
                          };
                        }
                      }
                      return null;
                    })();

                    if (
                      cart.gocart.bundle_dsc == null &&
                      !cart.gocart.is_yum_member
                    )
                      cart.gocart.bundle_price =
                        cart.gocart.original_total_price;

                    var _savings =
                      (cart.gocart.original_total_price -
                        cart.gocart.bundle_price) /
                      100;
                    var _yearly_savings = Math.ceil(
                      (cart.gocart.original_total_price / 100) * 0.25 * 13
                    );
                    var _pdp_order_savings = _contains_membership
                      ? Math.ceil(_savings)
                      : Math.ceil(_yearly_savings / 13);
                    cart.gocart.member_order_savings = _pdp_order_savings;

                    e.cart_obj = cart;
                    if (typeof update_prices === "function") {
                      update_prices();
                    }
                    var x = e.refreshBundles(cart);
                    return e.fetchHandler(cart, t);
                  })
                  .catch(function (t) {
                    $(".go-cart__checkout_btn").attr("disabled", false);
                    throw (e.ajaxRequestFail(), new Error(t));
                  });
              },
            },
            {
              key: "deleteItems",
              value: function (keys) {
                var e = this;
                window
                  .fetch("/cart/update.js", {
                    method: "POST",
                    credentials: "include",
                    headers: {
                      "Content-Type": "application/json",
                    },
                    body: JSON.stringify(keys),
                  })
                  .then(function (t) {
                    return t.json();
                  })
                  .then(function (t) {
                    return t;
                  });
              },
            },
            {
              key: "refreshBundles",
              value: function (t) {
                var e = this;
                var cart = t;
                cart.gocart.items = [];
                cart.gocart.updates = {};
                var _items = { items: [] };
                var _for_removal = { updates: {} };

                if (
                  cart.gocart.bfcm_promo &&
                  cart.gocart.missing_bfcm_gifts.length > 0
                ) {
                  cart.gocart.is_updated = false;
                  const gifts = e.cart_obj.gocart.missing_bfcm_gifts.map(
                    (g) => {
                      g.quantity = 1;
                      return g;
                    }
                  );
                  cart.gocart.items = [...gifts, ...cart.gocart.items];
                }

                if (
                  cart.gocart.easter_promo &&
                  cart.gocart.missing_easter_gifts.length > 0
                ) {
                  cart.gocart.is_updated = false;
                  const gifts = e.cart_obj.gocart.missing_easter_gifts.map(
                    (g) => {
                      g.quantity = 1;
                      return g;
                    }
                  );
                  cart.gocart.items = [...gifts, ...cart.gocart.items];
                }
                cart.items.forEach(function (i, r) {
                  var _target_sp_id = null;
                  // Check if item is subscription else skip
                  if (i.hasOwnProperty("selling_plan_allocation")) {
                    var _sp_alloc = i.selling_plan_allocation;
                    var _current_sp_name =
                      _sp_alloc.selling_plan.options[0].name;
                    var _current_sp_id = _sp_alloc.selling_plan.id;
                    var _target_sp_name = "";
                    var _is_in_bundle_sp = Object.keys(
                      e.selling_plan_group_mapping
                    ).includes(_current_sp_name);
                    var _subsave_name = _current_sp_name;
                    if (_is_in_bundle_sp) {
                      var _subsave_price = i.gocart.sub_save_base_price;
                      var _base_price = i.gocart.base_price;
                      var _subsave_dsc_amt = Math.round(
                        ((_base_price - _subsave_price) / _base_price) * 100
                      );
                      var _subsave_name = (function () {
                        // var keys = []

                        for (var key in e.selling_plan_group_mapping[
                          _current_sp_name
                        ].mappings) {
                          var _re = new RegExp(`\\b${_subsave_dsc_amt}\\%\\B`);
                          if (_re.test(key)) {
                            // keys.push(keys)
                            return key;
                          }
                        }
                      })();
                    }
                    if (cart.gocart.bundle_dsc) {
                      _target_sp_name = cart.gocart.bundle_dsc.name;
                    } else {
                      _target_sp_name =
                        i.selling_plan_allocation.selling_plan.options[0].name;
                      if (_is_in_bundle_sp) {
                        // Switch to non bundle
                        _target_sp_name = _subsave_name;
                      }
                    }
                    if (
                      _target_sp_name &&
                      _target_sp_name != _current_sp_name &&
                      i.variant_id != 44284368290010 &&
                      i.product_id != 8223924453594
                    ) {
                      cart.gocart.is_updated = false;
                      // Check if target is bundle
                      if (
                        Object.keys(e.selling_plan_group_mapping).includes(
                          _target_sp_name
                        )
                      ) {
                        // Switching from subsave to bundle selling plan
                        if (_is_in_bundle_sp) {
                          _subsave_sp_id = (function () {
                            for (var key in e.selling_plan_group_mapping[
                              _current_sp_name
                            ].mappings[_subsave_name]) {
                              var val =
                                e.selling_plan_group_mapping[_current_sp_name]
                                  .mappings[_subsave_name][key];
                              if (val == _current_sp_id) return key;
                            }
                          })();
                          _target_sp_id =
                            e.selling_plan_group_mapping[_target_sp_name]
                              .mappings[_subsave_name][_subsave_sp_id];
                        } else {
                          _target_sp_id =
                            e.selling_plan_group_mapping[_target_sp_name]
                              .mappings[_subsave_name][_current_sp_id];
                        }
                      } else {
                        var _subsave_sp_id = (function () {
                          var keys = [];
                          for (var key in e.selling_plan_group_mapping[
                            _current_sp_name
                          ].mappings[_subsave_name]) {
                            var val =
                              e.selling_plan_group_mapping[_current_sp_name]
                                .mappings[_subsave_name][key];
                            if (val == _current_sp_id) keys.push(key);
                          }
                          return keys.pop();
                        })();
                        _target_sp_id = _subsave_sp_id;
                      }
                      cart.gocart.items.push({
                        id: i.variant_id,
                        quantity: i.quantity,
                        selling_plan: _target_sp_id,
                      });
                      cart.gocart.updates[i.key] = 0;
                    } else {
                      cart.gocart.items.push({
                        id: i.variant_id,
                        quantity: i.quantity,
                        selling_plan: i.selling_plan_allocation.selling_plan.id,
                      });
                    }
                  } else {
                    cart.gocart.items.push({
                      id: i.variant_id,
                      quantity: i.quantity,
                    });
                  }
                });
                if (!cart.gocart.is_updated) {
                  if (cart.gocart.items.length > 0) {
                    // { id: 40383219990724 },
                    // { id: 44284368290010, selling_plan: 24372019418 },
                    const yumclubItems = cart.gocart.items.filter(
                      (item) => item.id === 44284368290010
                    );
                    const pppItems = cart.gocart.items.filter(
                      (item) =>
                        item.id === 40383219990724 &&
                        !Object.hasOwn(item, "selling_plan")
                    );
                    const otherItems = cart.gocart.items.filter(
                      (item) =>
                        (item.id !== 44284368290010 &&
                          item.id !== 40383219990724) ||
                        (item.id === 40383219990724 &&
                          Object.hasOwn(item, "selling_plan"))
                    );
                    cart.gocart.items = [
                      ...yumclubItems,
                      ...pppItems,
                      ...otherItems,
                    ];
                    e.clearCart(e.addMultipleItemsToCart);
                  }
                } else {
                  $(".go-cart__checkout_btn").attr("disabled", false);
                }
                return "DONE";
              },
            },
            {
              key: "addMultipleItemsToCart",
              value: function (e) {
                window
                  .fetch("/cart/add.js", {
                    method: "POST",
                    credentials: "include",
                    headers: {
                      "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                      items: e.cart_obj.gocart.items.reverse(),
                    }),
                  })
                  .then(function (t) {
                    // e.cart_obj.gocart.is_updated = true
                    return t.json();
                  })
                  .then(function (t) {
                    e.fetchCart();
                    return t;
                  })
                  .catch(function (t) {
                    throw (e.ajaxRequestFail(), new Error(t));
                  });
              },
            },
            {
              key: "addItemToCart",
              value: async function (t) {
                var e = this,
                  r = document.querySelector("#".concat(t)),
                  a = f()(r, {
                    hash: !0,
                  });

                if (
                  a.add_membership == "on" &&
                  !e.cart_obj.gocart.contains_membership
                ) {
                  a.items = [
                    {
                      id: 44284368290010,
                      quantity: 1,
                      selling_plan: 24372019418,
                    },
                  ];
                }

                // if (e.cart_obj.gocart.missing_bfcm_gifts.length) {
                //   const gifts = e.cart_obj.gocart.missing_bfcm_gifts.map(
                //     (g) => {
                //       g.quantity = g.id === 44284368290010 ? 2 : 1;
                //       return g;
                //     }
                //   );
                //   if (Object.hasOwn(a, "items")) {
                //     a.items = [...a.items, ...gifts];
                //   } else {
                //     a.items = [...gifts];
                //   }
                // }

                window
                  .fetch("/cart/add.js", {
                    method: "POST",
                    credentials: "include",
                    headers: {
                      "Content-Type": "application/json",
                    },
                    body: JSON.stringify(a),
                  })
                  .then(function (t) {
                    return t.json();
                  })
                  .then(async function (t) {
                    jQuery(
                      `.go_cart_drawer_upsell_item[data-id="${t.variant_id}"`
                    ).remove();
                    return e.addItemToCartHandler(t);
                  })
                  .catch(function (t) {
                    throw (e.ajaxRequestFail(), new Error(t));
                  });
              },
            },
            {
              key: "addItem",
              value: function (
                variantId,
                quantity,
                selling_plan = null,
                callback = null
              ) {
                var e = this;
                window
                  .fetch("/cart/add.js", {
                    method: "POST",
                    credentials: "include",
                    headers: {
                      "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                      id: variantId,
                      quantity: quantity,
                      selling_plan: selling_plan,
                    }),
                  })
                  .then(function (t) {
                    return t.json();
                  })
                  .then(function (t) {
                    // if (callback != null)
                    //   return callback()
                    // return null
                    return e.addItemToCartHandler(t);
                  })
                  .catch(function (t) {
                    throw (e.ajaxRequestFail(), new Error(t));
                  });
              },
            },
            {
              key: "addUpsellItem",
              value: function (variantId, quantity) {
                var e = this;
                window
                  .fetch("/cart/add.js", {
                    method: "POST",
                    credentials: "include",
                    headers: {
                      "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                      id: variantId,
                      quantity: quantity,
                      selling_plan:
                        variantId == 43753074622682
                          ? null
                          : [
                              "44577110065370",
                              "43941562056922",
                              "44014762688730",
                            ].includes(variantId)
                          ? 24230428890
                          : 24230527194,
                    }),
                  })
                  .then(function (t) {
                    return t.json();
                  })
                  .then(function (t) {
                    jQuery(
                      `.go_cart_drawer_upsell_item[data-id="${variantId}"`
                    ).remove();
                    return e.addItemToCartHandler(t);
                  })
                  .catch(function (t) {
                    throw (e.ajaxRequestFail(), new Error(t));
                  });
              },
            },
            {
              key: "clearCart",
              value: function (callback = null) {
                e = this;
                window
                  .fetch("/cart/clear.js", {
                    method: "POST",
                    credentials: "include",
                    headers: {
                      "Content-Type": "application/json",
                    },
                  })
                  .then(function (t) {
                    return t;
                  })
                  .then(function (t) {
                    if (e != null) return callback(e);
                    else return t.json;
                  })
                  .catch(function (t) {
                    throw (e.ajaxRequestFail(), new Error(t));
                  });
              },
            },

            {
              key: "removeItem",
              value: function (t) {
                var e = this;
                window
                  .fetch("/cart/change.js", {
                    method: "POST",
                    credentials: "same-origin",
                    body: JSON.stringify({
                      quantity: 0,
                      line: t,
                    }),
                    headers: {
                      "Content-Type": "application/json",
                    },
                  })
                  .then(function (t) {
                    return t.json();
                  })
                  .then(function () {
                    return e.fetchCart();
                  })
                  .catch(function (t) {
                    throw (e.ajaxRequestFail(), new Error(t));
                  });
              },
            },
            {
              key: "changeItemQuantity",
              value: function (t, e) {
                var r = this;
                window
                  .fetch("/cart/change.js", {
                    method: "POST",
                    credentials: "same-origin",
                    body: JSON.stringify({
                      quantity: e,
                      line: t,
                    }),
                    headers: {
                      "Content-Type": "application/json",
                    },
                  })
                  .then(function (t) {
                    return t.json();
                  })
                  .then(function () {
                    return r.fetchCart();
                  })
                  .catch(function (t) {
                    throw (r.ajaxRequestFail(), new Error(t));
                  });
              },
            },
            {
              key: "cartItemCount",
              value: function (t) {
                this.cartCount.innerHTML = t.item_count;
              },
            },
            {
              key: "fetchAndOpenCart",
              value: function () {
                var t = this;
                this.fetchCart(function () {
                  t.isDrawerMode ? t.openCartDrawer() : t.openMiniCart(),
                    t.openCartOverlay();
                });
              },
            },
            {
              key: "fetchAndOpenModal",
              value: function (t) {
                var e = this;
                this.fetchCart(function () {
                  e.renderCartModal(t), e.openCartModal(), e.openCartOverlay();
                });
              },
            },
            {
              key: "fetchHandler",
              value: function (t, e) {
                this.cartItemCount(t),
                  this.isDrawerMode
                    ? 0 === t.item_count
                      ? (this.renderBlankCartDrawer(),
                        $(".go-cart__checkout_btn").attr("disabled", true))
                      : // this.cartDrawerFooter.classList.add("is-invisible")
                        (this.renderDrawerCart(t),
                        this.cartDrawerFooter.classList.remove("is-invisible"),
                        $(".go-cart__checkout_btn").attr("disabled", false),
                        "function" === typeof e && e(t))
                    : 0 === t.item_count
                    ? (this.renderBlankMiniCart(),
                      this.cartMiniCartFooter.classList.add("is-invisible"))
                    : (this.renderMiniCart(t),
                      this.cartMiniCartFooter.classList.remove("is-invisible"),
                      "function" === typeof e && e(t));
              },
            },
            {
              key: "addItemToCartHandler",
              value: function (t) {
                return this.displayModal
                  ? this.fetchAndOpenModal(t)
                  : this.fetchAndOpenCart();
              },
            },
            {
              key: "ajaxRequestFail",
              value: function () {
                this.openFailModal(), this.openCartOverlay();
              },
            },
            {
              key: "renderCartModal",
              value: function (t) {
                this.clearCartModal();
                var e = t.variant_title;
                e = null === e ? "" : "(".concat(e, ")");
                var r =
                  '\n        <div class="go-cart-modal-item">\n            <div class="go-cart-item__image" style="background-image: url('
                    .concat(
                      t.image,
                      ');"></div>\n            <div class="go-cart-item__info">\n                <a href="'
                    )
                    .concat(t.url, '" class="go-cart-item__title">')
                    .concat(t.product_title, " ")
                    .concat(e, "</a> ")
                    .concat(
                      this.labelAddedToCart,
                      "\n            </div>\n        </div>\n      "
                    );
                this.cartModalContent.innerHTML += r;
              },
            },
            {
              key: "initUpsellItems",
              value: function () {
                var promises = [];
                topperHandles.forEach(function (handle) {
                  promises.push(
                    new Promise((resolve, reject) => {
                      window
                        .fetch(`/products/${handle}.js`, {
                          credentials: "same-origin",
                          method: "GET",
                        })
                        .then((rsp) => rsp.json())
                        .then((d) => resolve(d));
                    })
                  );
                });
                Promise.all(promises)
                  .then((values) => {
                    this.upsell_items_obj = values;
                    return values;
                  })
                  .then((v) => this.renderUpsellItems(v));
              },
            },
            {
              key: "renderUpsellItems",
              value: function (i) {
                var e = this;
                i.forEach(function (data, index) {
                  var compare_price = "";
                  if (
                    data.compare_at_price > 0 &&
                    data.compare_at_price != data.price
                  ) {
                    compare_price = formatMoney(
                      data.compare_at_price,
                      e.moneyFormat
                    );
                  }
                  var orig_price = data.variants[0].selling_plan_allocations
                    .length
                    ? formatMoney(data.price, e.moneyFormat)
                    : compare_price;
                  var price = data.variants[0].selling_plan_allocations.length
                    ? data.variants[0].selling_plan_allocations.filter((n) => {
                        return (
                          n.selling_plan_group_id ==
                            "c8b255eb80cd031f0b4fc41c6226c096474a249e" ||
                          n.selling_plan_group_id ==
                            "ffbbcafe4bff7277533745316f11ec066fff1370" ||
                          n.selling_plan_group_id ==
                            "f58e20c346ac0aab7cf9bc9acab3448f62a95f56"
                        );
                      })[0].price
                    : data.price;

                  var upsell_item = `<div class="go_cart_drawer_upsell_item" data-id=${
                    data.variants[0].id
                  } data-order=${index}>
                                        <div class="go_cart_drawer_upsell_item_img" style="background-image: url(${
                                          data.featured_image
                                        });"></div>
                                        <div class="go_cart_drawer_upsell_item_info">
                                            <div class="go_cart_drawer_upsell_item_name">${
                                              data.title.includes("Effect")
                                                ? "Cocomega book"
                                                : data.title
                                            }</div>
                                            <div class="go_cart_drawer_upsell_item_desc">${
                                              data.description
                                            }</div>
                                            <div class="go_cart_drawer_upsell_item_price">
                                                <span class="go_cart_drawer_upsell_item_actual_price">${formatMoney(
                                                  price
                                                )}</span>
                                                <span class="go_cart_drawer_upsell_item_base_price">${orig_price}</span>
                                            </div>
                                        </div>
                                        <div class="go_cart_drawer_upsell_item_add_btn_container">                                    
                                            <button class="go_cart_drawer_upsell_item_add_btn_wrapper js_upsell_item_add" 
                                            data-id=${
                                              data.variants[0].id
                                            }>+ Add</button>
                                        </div>
                                    </div>`;
                  var upsell_container = jQuery(
                    ".go_cart_drawer_upsell_items_container"
                  );
                  upsell_container.append(upsell_item);
                  jQuery(
                    `.js_upsell_item_add[data-id=${data.variants[0].id}]`
                  ).on("click", function (i) {
                    var data_id = jQuery(this).attr("data-id");
                    e.addUpsellItem(data_id, 1);
                  });
                });
              },
            },
            {
              key: "renderDrawerCart",
              value: async function (t) {
                var e = this;
                const max_dsc = bundle_t[bundle_t.length - 1];
                var total_price = t.gocart.original_total_price / 100;
                let nextHigher = null;
                let nextHigherIndex = null;
                for (let i = 0; i < bundle_t.length; i++) {
                  if (bundle_t[i] > total_price) {
                    if (nextHigher === null || bundle_t[i] < nextHigher) {
                      nextHigher = bundle_t[i];
                      nextHigherIndex = i;
                    }
                  } else {
                    nextHigher = bundle_t[bundle_t.length - 1];
                    nextHigherIndex = bundle_t.length - 1;
                  }
                }
                var slider_pct =
                  (total_price / nextHigher) *
                  ((nextHigherIndex + 1) * 0.25) *
                  100;
                if (slider_pct > 100) {
                  slider_pct = 100;
                }
                $(".go_cart_drawer__progress_bar_container").each(function () {
                  var _parent = this;
                  jQuery(".go_cart_drawer__progress_price", _parent).each(
                    function (idx) {
                      if (idx <= 0) {
                        jQuery(this).addClass("active");
                      } else {
                        if (total_price >= bundle_t[idx - 1]) {
                          jQuery(this).addClass("active");
                          jQuery(
                            `.go_cart_drawer__progress_rewards:eq(${idx})`,
                            _parent
                          ).addClass("active");
                          jQuery(
                            `.go_cart_drawer__progress_bar_milestone_text_container:eq(${idx})`,
                            _parent
                          ).addClass("active");
                        } else {
                          jQuery(this).removeClass("active");
                          jQuery(
                            `.go_cart_drawer__progress_rewards:eq(${idx})`,
                            _parent
                          ).removeClass("active");
                          jQuery(
                            `.go_cart_drawer__progress_bar_milestone_text_container:eq(${idx})`,
                            _parent
                          ).removeClass("active");
                        }
                      }
                    }
                  );
                });
                var dsc_pct =
                  t.gocart.bundle_dsc == null ? 0 : t.gocart.bundle_dsc;
                jQuery(".go_cart_drawer__progress_bar_fg").css(
                  "width",
                  `${slider_pct}%`
                );
                jQuery("#goCartCheckout").off("click");
                jQuery("#goCartCheckout").on("click", async function () {
                  var _coupon = null;
                  var coupons = [];
                  var codes_cookies = getCookie("discount_code");
                  if (codes_cookies) {
                    coupons.push(codes_cookies);
                  }
                  if (t.gocart.is_yum_member) {
                    _coupon = "YUMCLUB";
                  } else {
                    if (
                      (t.gocart.contains_onetime && t.gocart.contains_subs) ||
                      (t.gocart.contains_membership &&
                        t.gocart.contains_onetime)
                    ) {
                      //send api req to get applicable discount code
                      function gen_code(cart) {
                        var _cart = {
                          gocart: cart.gocart,
                          original_total_price: cart.original_total_price,
                          items: cart.items,
                        };
                        return window
                          .fetch("https://my.yumwoof.com/gen_bundle_coupon", {
                            method: "POST",
                            headers: {
                              "Content-Type": "application/json",
                            },
                            body: JSON.stringify(_cart),
                          })
                          .then(function (t) {
                            return t.json();
                          });
                      }
                      var _rsp = await gen_code(t);
                      if (_rsp.code != null) {
                        _coupon = _rsp.code;
                      }
                    }
                  }
                  if (_coupon) {
                    coupons.push(_coupon);
                  }
                  if (
                    coupons.includes("POOPHERO") &&
                    (t.gocart.contains_membership || t.gocart.is_yum_member)
                  ) {
                    coupons.push("YUMCLUB-POOPHERO");
                  }
                  if (
                    coupons.includes("PERFECTJUNE") &&
                    (t.gocart.contains_membership || t.gocart.is_yum_member)
                  ) {
                    coupons.push("YUMCLUB-PERFECTJUNE");
                  }
                  if (
                    coupons.includes("FETCH15OFF") &&
                    (t.gocart.contains_membership || t.gocart.is_yum_member)
                  ) {
                    coupons.push("YUMCLUB-FETCH15OFF");
                  }
                  window.location.href = `/checkout?discount=${coupons.join(
                    ","
                  )}`;
                });

                var initial_dsc = dsc_pct;
                var is_subscribed =
                  window.sessionStorage.getItem("is_subscribed") === "true";
                if (is_subscribed) {
                  dsc_pct =
                    (1 - (1 - dsc_pct / 100) * (1 - 0.3)).toFixed(2) * 100;
                }
                var e = this;
                this.clearCartDrawer(),
                  t.items.forEach(function (t, r) {
                    if (topperHandles.includes(t.handle)) {
                      topperHandles.splice(topperHandles.indexOf(t.handle), 1);
                    }
                    var a = t.variant_title;
                    null === a && (a = "");
                    var product_title = t.product_title.includes("Effect")
                      ? "Cocomega book"
                      : t.product_title;

                    var recipes = t.options_with_values.filter(
                      (o) => o["name"] == "Recipe"
                    );
                    var recipe_txt = recipes[0]
                      ? `${recipes[0]["value"]} | `
                      : "";

                    // if (t.product_id == 7847669956826) {
                    //   var time_now = Date.parse(new Date().toUTCString());
                    //   var last_opened =
                    //     Object.is(
                    //       Date.parse(
                    //         window.sessionStorage.getItem("last_opened")
                    //       ),
                    //       NaN
                    //     ) === true
                    //       ? 0
                    //       : Date.parse(
                    //           window.sessionStorage.getItem("last_opened")
                    //         );

                    //   if (t.quantity >= 3) {
                    //     if (
                    //       !is_subscribed &&
                    //       window.location.pathname ==
                    //         "/products/perfect-kibble" &&
                    //       (time_now - last_opened) / 1000 >= 86400
                    //     ) {
                    //       window._klOnsite = window._klOnsite || [];
                    //       window._klOnsite.push(["openForm", "QZAC2x"]);
                    //     }
                    //   } else {
                    //     dsc_pct = initial_dsc;
                    //   }
                    // }
                    var orig_item_price =
                      t.gocart.sub_save_price > t.gocart.bundle_price
                        ? formatMoney(t.gocart.sub_save_price, e.moneyFormat)
                        : "";
                    var extra_item_price = "";
                    var dsc_item_price = formatMoney(
                      t.gocart.bundle_price,
                      e.moneyFormat
                    );
                    if (
                      e.cart_obj.gocart.bfcm_code == "PAWLUV"
                      // || e.cart_obj.gocart.bfcm_code == "SPRING20"
                    ) {
                      extra_item_price = dsc_item_price;
                      dsc_item_price = formatMoney(
                        t.gocart.bundle_price *
                          e.cart_obj.gocart.bfcm_value_pct,
                        e.moneyFormat
                      );
                    }
                    if (
                      e.cart_obj.gocart.bfcm_promo ||
                      e.cart_obj.gocart.easter_promo
                    ) {
                      extra_item_price = dsc_item_price;
                      if (
                        (t.variant_id === 40383219990724 &&
                          !Object.hasOwn(t, "selling_plan_allocation")) ||
                        t.variant_id === 44284368290010 ||
                        (t.variant_id === 43331315892442 &&
                          !Object.hasOwn(t, "selling_plan_allocation"))
                      ) {
                        // const _multiplier =
                        //   t.variant_id === 44284368290010 ? 2 : 1;
                        // orig_item_price = "";
                        // extra_item_price = "";
                        var dct =
                          t.variant_id === 44284368290010
                            ? 1
                            : e.cart_obj.gocart.bfcm_value_pct;

                        if (e.cart_obj.gocart.easter_promo) {
                          dct = e.cart_obj.gocart.bfcm_value_pct;
                        }
                        dsc_item_price = formatMoney(
                          (t.gocart.bundle_price -
                            (t.gocart.bundle_price / t.quantity) * 1) *
                            dct,
                          e.moneyFormat
                        );
                      } else {
                        dsc_item_price = formatMoney(
                          t.gocart.bundle_price *
                            e.cart_obj.gocart.bfcm_value_pct,
                          e.moneyFormat
                        );
                      }
                      // { id: 40383219990724 },
                      // { id: 44284368290010, selling_plan: 24372019418 },

                      if (
                        t.variant_id === 44284368290010 &&
                        e.cart_obj.gocart.easter_promo
                      ) {
                        // orig_item_price = "";
                        // extra_item_price = "";
                        dsc_item_price = formatMoney(
                          t.gocart.bundle_price *
                            e.cart_obj.gocart.bfcm_value_pct,
                          e.moneyFormat
                        );
                      }
                    }
                    if (t.handle.includes("sampler")) {
                      var qty_input_selector = `
                             <span class="go-cart-item__quantity-button minus js-go-cart-quantity-minus js-samples-watcher-minus" disabled> - </span>
                             <input class="go-cart-item__quantity-number js-go-cart-quantity js-samples-watcher-input" value="${t.quantity}" type="number" min="0" pattern="[0-9]*" max="1" disabled>                          
                             <span class="go-cart-item__quantity-button plus js-go-cart-quantity-plus js-samples-watcher-plus" disabled> +</span >`;
                    } else {
                      var qty_input_selector = `
                          <span class="go-cart-item__quantity-button minus js-go-cart-quantity-minus"> - </span>    
                          <input class="go-cart-item__quantity-number js-go-cart-quantity" type="number" value="${t.quantity}">
                          <span class="go-cart-item__quantity-button plus js-go-cart-quantity-plus"> +</span >`;
                    }

                    var selling_plan_txt = t.hasOwnProperty(
                      "selling_plan_allocation"
                    )
                      ? `Subscription | ${t.selling_plan_allocation.selling_plan.name}`
                      : "One-time purchase";
                    var o = `<div class="go-cart-item__single" data-line="${Number(
                      r + 1
                    )}" data-var-id="${t.variant_id}">
									<div class="go-cart-item__info-wrapper">
										<a href="${
                      t.url
                    }"><div class="go-cart-item__image" style="background-image: url(${
                      t.image
                    });"></div></a>
											<div class="go-cart-item__info">
												<div class="go_cart_item_info_container">
													<a href="${t.url}" class="go-cart-item_title">${product_title}</a>
													<a class="go-cart-item__remove ${e.removeFromCartNoDot}">${e.labelRemove}</a>
												</div>
                                             
												<div class="go_cart_item_variant_txts_container">
													${recipe_txt}${selling_plan_txt}
												</div>
												   <div class="go-cart-item__variant"></div>
												<div class="go-cart-item__quantity">
													<div class="go_cart_item_qty_selector_container">
														<span class="go-cart-item__quantity-label">${e.labelQuantity}</span>
														${qty_input_selector}
													</div>      
                                                    <div>
                                                      <span class="go-cart-item__dsc_price">${orig_item_price}</span>
                                                      <span class="go-cart-item__dsc_price">${extra_item_price}</span>
                                                      <span class="go-cart-item__price">${
                                                        dsc_item_price ===
                                                        "$0.00"
                                                          ? "FREE"
                                                          : dsc_item_price
                                                      }</span>
                                                    </div>
												</div>
											</div>
										</div>										
									</div>`;

                    // e.cartDrawerContent.innerHTML += o;
                    $(e.cartDrawerContent).append(o);
                  }),
                  $(this.cartDrawerSubTotal).html(
                    formatMoney(t.gocart.original_total_price, this.moneyFormat)
                  );
                if (
                  this.cart_obj.gocart.bfcm_code == "PAWLUV"
                  // || this.cart_obj.gocart.bfcm_code == "SPRING20"
                ) {
                  $(this.cartDrawerExtraDscTotal).html(
                    formatMoney(t.gocart.bundle_price, this.moneyFormat)
                  ),
                    $(this.cartDrawerDscTotal).html(
                      formatMoney(
                        t.gocart.bundle_price *
                          this.cart_obj.gocart.bfcm_value_pct,
                        this.moneyFormat
                      )
                    );
                } else if (this.cart_obj.gocart.bfcm_promo) {
                  $(this.cartDrawerExtraDscTotal).html(
                    formatMoney(t.gocart.bundle_price, this.moneyFormat)
                  ),
                    $(this.cartDrawerDscTotal).html(
                      formatMoney(
                        (t.gocart.bundle_price - 2900 - 3093) *
                          this.cart_obj.gocart.bfcm_value_pct,
                        this.moneyFormat
                      )
                    );
                } else if (this.cart_obj.gocart.easter_promo) {
                  const less =
                    this.cart_obj.gocart.is_yum_member ||
                    this.cart_obj.gocart.contains_membership
                      ? 3093
                      : 4124;

                  $(this.cartDrawerExtraDscTotal).html(
                    formatMoney(t.gocart.bundle_price, this.moneyFormat)
                  ),
                    $(this.cartDrawerDscTotal).html(
                      formatMoney(
                        (t.gocart.bundle_price - less) *
                          this.cart_obj.gocart.bfcm_value_pct,
                        this.moneyFormat
                      )
                    );
                } else {
                  $(this.cartDrawerExtraDscTotal).html(
                    formatMoney(
                      t.original_total_price * (1 - initial_dsc / 100),
                      this.moneyFormat
                    )
                  ),
                    $(this.cartDrawerDscTotal).html(
                      formatMoney(t.gocart.bundle_price, this.moneyFormat)
                    );
                }
                $(this.cartDrawerSubTotal).parent().removeClass("is-invisible"),
                  document
                    .querySelectorAll(this.removeFromCart)
                    .forEach(function (t) {
                      t.addEventListener("click", function () {
                        GoCart.removeItemAnimation(t.parentNode);
                        var r =
                          t.parentNode.parentNode.parentNode.parentNode.getAttribute(
                            "data-line"
                          );
                        e.removeItem(r);
                      });
                    }),
                  document
                    .querySelectorAll(this.itemQuantityPlus)
                    .forEach(function (t) {
                      var isSample = jQuery(t)
                        .attr("class")
                        .includes("js-samples-watcher");
                      if (!isSample) {
                        var _disable = false;
                        if (e.cart_obj.gocart.bfcm_promo) {
                          if (
                            $(t)
                              .parents(".go-cart-item__single")
                              .attr("data-var-id") === "44284368290010"
                          ) {
                            $(t).addClass("disabled");
                            _disable = true;
                          }
                        }
                        if (!_disable) {
                          t.addEventListener("click", function () {
                            var r =
                                t.parentNode.parentNode.parentNode.parentNode.parentNode.getAttribute(
                                  "data-line"
                                ),
                              a =
                                Number(
                                  t.parentNode.querySelector(e.itemQuantity)
                                    .value
                                ) + 1;

                            e.changeItemQuantity(r, a);
                          });
                        }
                      }
                    }),
                  document
                    .querySelectorAll(this.itemQuantityMinus)
                    .forEach(function (t) {
                      var isSample = jQuery(t)
                        .attr("class")
                        .includes("js-samples-watcher");
                      if (!isSample) {
                        var _disable = false;
                        if (e.cart_obj.gocart.bfcm_promo) {
                          if (
                            $(t)
                              .parents(".go-cart-item__single")
                              .attr("data-var-id") === "44284368290010"
                          ) {
                            $(t).addClass("disabled");
                            $(t).prop("disabled", true);
                            _disable = true;
                          }
                        }
                        if (!_disable) {
                          t.addEventListener("click", function () {
                            var r =
                                t.parentNode.parentNode.parentNode.parentNode.parentNode.getAttribute(
                                  "data-line"
                                ),
                              a =
                                Number(
                                  t.parentNode.querySelector(e.itemQuantity)
                                    .value
                                ) - 1;
                            e.changeItemQuantity(r, a),
                              0 ===
                                Number(
                                  t.parentNode.querySelector(e.itemQuantity)
                                    .value - 1
                                ) &&
                                GoCart.removeItemAnimation(
                                  t.parentNode.parentNode.parentNode.parentNode
                                );
                          });
                        }
                      }
                    }),
                  document
                    .querySelectorAll(this.itemQuantity)
                    .forEach(function (t) {
                      var _disable = false;
                      if (e.cart_obj.gocart.bfcm_promo) {
                        if (
                          $(t)
                            .parents(".go-cart-item__single")
                            .attr("data-var-id") === "44284368290010"
                        ) {
                          _disable = true;
                          $(t).prop("disabled", true);
                        }
                      }

                      t.addEventListener("change", function (i) {
                        var num = i.target.value;
                        var r =
                          i.target.parentNode.parentNode.parentNode.parentNode.parentNode.getAttribute(
                            "data-line"
                          );
                        if (_disable) {
                          num = 1;
                        }
                        e.changeItemQuantity(r, num);
                      });
                    });
                if (
                  $(this.cartDrawerSubTotal).html() ==
                  $(this.cartDrawerDscTotal).html()
                ) {
                  jQuery(this.cartDrawerDscTotal).hide();
                  jQuery(this.cartDrawerSubTotal).css({
                    "text-decoration": "none",
                    color: "var(--headline-font-family)",
                    "font-weight": 700,
                  });
                } else {
                  jQuery(this.cartDrawerDscTotal).show();
                  jQuery(this.cartDrawerSubTotal).css({
                    "text-decoration": "line-through",
                    color: "#aa9b8a",
                    "font-weight": 400,
                  });
                }

                if (dsc_pct != initial_dsc) {
                  jQuery(this.cartDrawerExtraDscTotal).show();
                  jQuery(".go_cart_drawer_dsc_banner_container").show();
                } else {
                  jQuery(this.cartDrawerExtraDscTotal).hide();
                  jQuery(".go_cart_drawer_dsc_banner_container").hide();
                }

                if (
                  this.cart_obj.gocart.bfcm_promo ||
                  this.cart_obj.gocart.easter_promo
                ) {
                  jQuery(this.cartDrawerExtraDscTotal).show();
                }

                if (topperHandles.length <= 0) {
                  jQuery(".go_cart_drawer_upsell").css("display", "none");
                  jQuery(".go-cart-drawer__content").css("height", "100%");
                }

                if (
                  jQuery(".go_cart_drawer_upsell_items_container").children()
                    .length <= 0
                ) {
                  // topperHandles.forEach(function (i, index) {
                  //   window
                  //     .fetch(`/products/${i}.js`, {
                  //       credentials: "same-origin",
                  //       method: "GET",
                  //     })
                  //     .then((response) => response.json())
                  //     .then(function (data) {
                  //       var compare_price = "";
                  //       if (
                  //         data.compare_at_price > 0 &&
                  //         data.compare_at_price != data.price
                  //       ) {
                  //         compare_price = formatMoney(
                  //           data.compare_at_price,
                  //           e.moneyFormat
                  //         );
                  //       }
                  //       var orig_price = data.variants[0]
                  //         .selling_plan_allocations.length
                  //         ? formatMoney(data.price, e.moneyFormat)
                  //         : compare_price;
                  //       var price = data.variants[0].selling_plan_allocations
                  //         .length
                  //         ? data.variants[0].selling_plan_allocations.filter(n => { return n.selling_plan_group_id == "c8b255eb80cd031f0b4fc41c6226c096474a249e" })[0].price : data.price;
                  //       var upsell_item = `<div class="go_cart_drawer_upsell_item" data-id=${data.variants[0].id
                  //         } data-order=${index}>
                  //                   <div class="go_cart_drawer_upsell_item_img"
                  //                       style="background-image: url(${data.featured_image
                  //         });"></div>
                  //                   <div class="go_cart_drawer_upsell_item_info">
                  //                       <div class="go_cart_drawer_upsell_item_name">${data.title.includes("Effect")
                  //           ? "Cocomega book"
                  //           : data.title
                  //         }</div>
                  //                       <div class="go_cart_drawer_upsell_item_desc">${data.description
                  //         }</div>
                  //                       <div class="go_cart_drawer_upsell_item_price">
                  //                           <span class="go_cart_drawer_upsell_item_actual_price">${formatMoney(
                  //           price
                  //         )}</span>
                  //                           <span class="go_cart_drawer_upsell_item_base_price">${orig_price}</span>
                  //                       </div>
                  //                   </div>
                  //                   <div class="go_cart_drawer_upsell_item_add_btn_container">
                  //                       <button class="go_cart_drawer_upsell_item_add_btn_wrapper js_upsell_item_add" data-id=${data.variants[0].id
                  //         }>+ Add</button>
                  //                   </div>
                  //               </div>`;
                  //       var upsell_container = jQuery(
                  //         ".go_cart_drawer_upsell_items_container"
                  //       );
                  //       upsell_container.append(upsell_item);
                  //       jQuery(
                  //         `.js_upsell_item_add[data-id=${data.variants[0].id}]`
                  //       ).on("click", function (i) {
                  //         var data_id = jQuery(this).attr("data-id");
                  //         e.addUpsellItem(data_id, 1);
                  //       });
                  //     })
                  //     .then(function (data) {
                  //       if (
                  //         jQuery(".go_cart_drawer_upsell_item").length ==
                  //         topperHandles.length
                  //       ) {
                  //         var sorted_upsell_items = jQuery(
                  //           ".go_cart_drawer_upsell_item"
                  //         )
                  //           .detach()
                  //           .sort(function (a, b) {
                  //             return (
                  //               parseInt(a.getAttribute("data-order"), 10) -
                  //               parseInt(b.getAttribute("data-order"), 10)
                  //             );
                  //           });
                  //         jQuery(
                  //           ".go_cart_drawer_upsell_items_container"
                  //         ).append(sorted_upsell_items);
                  //       }
                  //     });
                  // });
                }
                // jQuery(e.cartAddMembership).off("click");
                // $(e.cartAddMembership).on("click", function () {
                //   e.addItem(44284368290010, 1, 24229904602);
                // });
                var _savings =
                  (t.gocart.original_total_price - t.gocart.bundle_price) / 100;
                var _yearly_savings = Math.ceil(
                  (t.gocart.original_total_price / 100) * 0.25 * 13
                );

                t.gocart.yearly_savings = _yearly_savings;
                var _pdp_order_savings = t.gocart.contains_membership
                  ? Math.ceil(_savings)
                  : Math.ceil(_yearly_savings / 13);
                t.gocart.order_savings = _pdp_order_savings;
                this.cart_obj = t;
                // go_cart_drawer__member_txt_savings member

                // var _member_savings_txt  = t.gocart.contains_membership?`You saved $${_savings * 13} every year` : `You saved $${_savings}`
                // e.cartMemberSavings.innerHTML = _savings > 0? _member_savings_txt : 'Your dog is extra cute today'
                $(e.cartMemberSavings).html(
                  _savings > 0
                    ? `You saved ${currency_sym}${Math.ceil(
                        _savings * 13
                      )} every year`
                    : "Your dog is extra cute today"
                );
                $(e.cartNonMemberSavings).html(
                  _yearly_savings > 0
                    ? `Save ${currency_sym}${_yearly_savings} every year`
                    : "Save on dog food"
                );
                // e.cartMemberOrderSavings.innerHTML = _pdp_order_savings > 0 ? `and save $${_pdp_order_savings} on this order` : 'Save on dog food'
                // e.cartMemberOrderSavings.setAttribute('data-order-savings',_pdp_order_savings > 0? _pdp_order_savings : 0)
                // var _savings = Math.ceil((t.gocart.original_total_price - t.gocart.bundle_price) / 100)
                // var _yearly_savings = Math.ceil((t.gocart.original_total_price / 100) * 0.25 * 13)
                // console.log("DDD", _yearly_savings)
                // var _member_savings_txt  = t.gocart.contains_membership?`You saved $${_yearly_savings - 129} every year` : `You saved $${_savings}`
                // e.cartMemberSavings.innerHTML  = _savings > 0? _member_savings_txt : 'Your dog is extra cute today'
                // e.cartNonMemberSavings.innerHTML = _yearly_savings > 0? `Save $${_yearly_savings} every year` : 'Save on dog food'

                if (t.gocart.contains_membership || t.gocart.is_yum_member) {
                  $(
                    ".go_cart_drawer__member_indicator",
                    ".go_cart_drawer_offer_membership_container"
                  ).hide();
                  $(".go_cart_drawer__member_indicator.current_member").show();
                  $(".go_cart_drawer__progress").hide();
                  $(".collection_banner_text").text(
                    "Your 25% discount has been applied."
                  );
                  $(".collection_banner_text_img").hide();
                  $(".collection_banner_text_img.member").show();
                } else {
                  $(".go_cart_drawer__progress").show();
                  $(
                    ".go_cart_drawer__member_indicator",
                    ".go_cart_drawer_offer_membership_container"
                  ).show();
                  $(".go_cart_drawer__member_indicator.current_member").hide();
                  $(".collection_banner_text").text("Enjoy 25% Off All Orders");
                  $(".collection_banner_text_img").show();
                  $(".collection_banner_text_img.member").hide();
                }
              },
            },
            {
              key: "renderMiniCart",
              value: function (t) {
                var e = this;
                this.clearMiniCart(),
                  t.items.forEach(function (t, r) {
                    var a = t.variant_title;
                    null === a && (a = "");
                    var o =
                      '\n        <div class="go-cart-item__single" data-line="'
                        .concat(
                          Number(r + 1),
                          '">\n            <div class="go-cart-item__info-wrapper">\n                <div class="go-cart-item__image" style="background-image: url('
                        )
                        .concat(
                          t.image,
                          ');"></div>\n                <div class="go-cart-item__info">\n                    <a href="'
                        )
                        .concat(t.url, '" class="go-cart-item__title">')
                        .concat(
                          t.product_title,
                          '</a>\n                    <div class="go-cart-item__variant">'
                        )
                        .concat(
                          a,
                          '</div>\n                    <div class="go-cart-item__quantity">\n                        <span class="go-cart-item__quantity-label">'
                        )
                        .concat(
                          e.labelQuantity,
                          ' </span>\n                        <span class="go-cart-item__quantity-button js-go-cart-quantity-minus">-</span>\n                        <input class="go-cart-item__quantity-number js-go-cart-quantity" type="number" value="'
                        )
                        .concat(
                          t.quantity,
                          '" disabled>\n                        <span class="go-cart-item__quantity-button js-go-cart-quantity-plus">+</span>\n                    </div>\n                </div>\n            </div>\n            <div class="go-cart-item__price">'
                        )
                        .concat(
                          formatMoney(t.original_line_price, e.moneyFormat),
                          '</div>\n            <a class="go-cart-item__remove '
                        )
                        .concat(e.removeFromCartNoDot, '">')
                        .concat(e.labelRemove, "</a>\n        </div>\n      ");
                    e.cartMiniCartContent.innerHTML += o;
                  }),
                  (this.cartMiniCartSubTotal.innerHTML = formatMoney(
                    t.original_total_price,
                    this.moneyFormat
                  )),
                  this.cartMiniCartSubTotal.parentNode.classList.remove(
                    "is-invisible"
                  ),
                  document
                    .querySelectorAll(this.removeFromCart)
                    .forEach(function (t) {
                      t.addEventListener("click", function () {
                        GoCart.removeItemAnimation(t.parentNode);
                        var r = t.parentNode.getAttribute("data-line");
                        e.removeItem(r);
                      });
                    }),
                  document
                    .querySelectorAll(this.itemQuantityPlus)
                    .forEach(function (t) {
                      t.addEventListener("click", function () {
                        var r =
                            t.parentNode.parentNode.parentNode.parentNode.parentNode.getAttribute(
                              "data-line"
                            ),
                          a =
                            Number(
                              t.parentNode.querySelector(e.itemQuantity).value
                            ) + 1;
                        e.changeItemQuantity(r, a);
                      });
                    }),
                  document
                    .querySelectorAll(this.itemQuantityMinus)
                    .forEach(function (t) {
                      t.addEventListener("click", function () {
                        var r =
                            t.parentNode.parentNode.parentNode.parentNode.parentNode.getAttribute(
                              "data-line"
                            ),
                          a =
                            Number(
                              t.parentNode.querySelector(e.itemQuantity).value
                            ) - 1;
                        e.changeItemQuantity(r, a),
                          0 ===
                            Number(
                              t.parentNode.querySelector(e.itemQuantity).value -
                                1
                            ) &&
                            GoCart.removeItemAnimation(
                              t.parentNode.parentNode.parentNode.parentNode
                            );
                      });
                    });
              },
            },
            {
              key: "renderBlankCartDrawer",
              value: function () {
                if (topperHandles.length <= 0) {
                  jQuery(".go_cart_drawer_upsell").css("display", "none");
                  jQuery(".go-cart-drawer__content").css("height", "100%");
                }
                $(this.cartDrawerSubTotal).parent().addClass("is-invisible"),
                  this.clearCartDrawer(),
                  $(this.cartDrawerContent).html(
                    '<div class="go-cart__empty">'.concat(
                      this.labelCartIsEmpty,
                      "</div>"
                    )
                  );
                $(this.cartMemberSavings).html("your dog is extra cute today");
                $(this.cartNonMemberSavings).html("Save on dog food");
                if (this.cart_obj.gocart.is_yum_member) {
                  $(
                    ".go_cart_drawer__member_indicator",
                    ".go_cart_drawer_offer_membership_container"
                  ).hide();
                  $(".go_cart_drawer__member_indicator.current_member").show();
                  $(".go_cart_drawer__progress").hide();
                } else {
                  $(".go_cart_drawer__progress").show();
                  $(
                    ".go_cart_drawer__member_indicator",
                    ".go_cart_drawer_offer_membership_container"
                  ).show();
                  $(".go_cart_drawer__member_indicator.current_member").hide();
                }
                jQuery(".go_cart_drawer__progress_bar_fg").css("width", `0%`);
                jQuery(".go_cart_drawer__progress_price")
                  .slice(1)
                  .removeClass("active");
                jQuery(".go_cart_drawer__progress_bar_milestone_text_container")
                  .slice(1)
                  .removeClass("active");
              },
            },
            {
              key: "renderBlankMiniCart",
              value: function () {
                this.cartMiniCartSubTotal.parentNode.classList.add(
                  "is-invisible"
                ),
                  this.clearMiniCart(),
                  (this.cartMiniCartContent.innerHTML =
                    '<div class="go-cart__empty">'.concat(
                      this.labelCartIsEmpty,
                      "</div>"
                    ));
              },
            },
            {
              key: "clearCartDrawer",
              value: function () {
                $(this.cartDrawerContent).html("");
              },
            },
            {
              key: "clearMiniCart",
              value: function () {
                this.cartMiniCartContent.innerHTML = "";
              },
            },
            {
              key: "clearCartModal",
              value: function () {
                this.cartModalContent.innerHTML = "";
              },
            },
            {
              key: "openCartDrawer",
              value: function () {
                this.cartDrawer.classList.add("is-open");
              },
            },
            {
              key: "closeCartDrawer",
              value: function () {
                this.cartDrawer.classList.remove("is-open");
              },
            },
            {
              key: "openMiniCart",
              value: function () {
                this.cartMiniCart.classList.add("is-open");
              },
            },
            {
              key: "closeMiniCart",
              value: function () {
                this.cartMiniCart.classList.remove("is-open");
              },
            },
            {
              key: "openFailModal",
              value: function () {
                this.cartModalFail.classList.add("is-open");
              },
            },
            {
              key: "closeFailModal",
              value: function () {
                this.cartModalFail.classList.remove("is-open");
              },
            },
            {
              key: "openCartModal",
              value: function () {
                this.cartModal.classList.add("is-open");
              },
            },
            {
              key: "closeCartModal",
              value: function () {
                this.cartModal.classList.remove("is-open");
              },
            },
            {
              key: "openCartOverlay",
              value: function () {
                this.cartOverlay.classList.add("is-open");
              },
            },
            {
              key: "closeCartOverlay",
              value: function () {
                this.cartOverlay.classList.remove("is-open");
              },
            },
            {
              key: "setDrawerDirection",
              value: function () {
                this.cartDrawer.classList.add(
                  "go-cart__drawer--".concat(this.drawerDirection)
                );
              },
            },
            {
              key: "isDrawerMode",
              get: function () {
                return "drawer" === this.cartMode;
              },
            },
          ]) && _defineProperties(t.prototype, e),
          r && _defineProperties(t, r),
          GoCart
        );
      })();
      e.default = h;
    },
  ]).default;
});

//# sourceMappingURL=index.js.map
